(() => {
  const preserveScrollWhenDrawerCloses = (drawer, scrollY, returnFocusEl) => {
    const obs = new MutationObserver(() => {
      if (drawer.classList.contains('open')) return;
      obs.disconnect();
      requestAnimationFrame(() => {
        window.scrollTo({ top: scrollY, left: 0, behavior: 'instant' });
        if (returnFocusEl?.focus) {
          try {
            returnFocusEl.focus({ preventScroll: true });
          } catch {
            returnFocusEl.focus();
          }
        }
      });
    });
    obs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  };

  const openProductPreorderDrawer = (variantId, returnFocusEl) => {
    const scrollY = window.scrollY;
    const anchor =
      document.querySelector('product-info [data-pre-order-request-anchor]') ||
      document.querySelector('[data-pre-order-request-anchor]');
    const openerId = anchor?.dataset?.preOrderOpenerButtonId;
    const openerBtn = openerId ? document.getElementById(openerId) : null;
    const drawerSelector = openerBtn?.closest('side-drawer-opener')?.getAttribute('data-side-drawer');
    const drawer = drawerSelector ? document.querySelector(drawerSelector) : null;
    const productInfo = document.querySelector('product-info');
    const sectionId = productInfo?.dataset?.originalSection || productInfo?.dataset?.section;
    const vid = variantId ? String(variantId) : '';

    if (drawer && vid) {
      drawer.setAttribute('data-pre-order-pending-variant-id', vid);
    }

    if (sectionId && vid) {
      const variantInput = document.querySelector(
        `#product-form-${sectionId} input[name="id"].product-variant-id, #product-form-${sectionId} input[name="id"]`
      );
      if (variantInput) {
        variantInput.value = vid;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (openerBtn) {
      if (returnFocusEl && drawer) {
        preserveScrollWhenDrawerCloses(drawer, scrollY, returnFocusEl);
      }
      openerBtn.click();
      if (returnFocusEl && drawer) {
        drawer.setActiveElement(returnFocusEl);
      }
      if (drawer && vid) {
        requestAnimationFrame(() => {
          if (typeof window.syncPreOrderUnavailableVariantSelect === 'function') {
            window.syncPreOrderUnavailableVariantSelect(drawer);
          }
        });
      }
    }
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-variant-grid-dialog]').forEach((dialog) => {
      if (dialog.dataset.variantGridDialogInit === 'true') return;
      dialog.dataset.variantGridDialogInit = 'true';
      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) dialog.close();
      });
    });

    root.querySelectorAll('[data-variant-grid-open]').forEach((btn) => {
      if (btn.dataset.variantGridBtnInit === 'true') return;
      btn.dataset.variantGridBtnInit = 'true';
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-variant-grid-open');
        const d = id ? document.getElementById(id) : null;
        if (d && typeof d.showModal === 'function') d.showModal();
      });
    });

    root.querySelectorAll('[data-variant-grid-pre-order]').forEach((btn) => {
      if (btn.dataset.variantGridPreOrderInit === 'true') return;
      btn.dataset.variantGridPreOrderInit = 'true';
      btn.addEventListener('click', () => {
        const vid = btn.getAttribute('data-variant-id');
        openProductPreorderDrawer(vid, btn);
      });
    });

    root.querySelectorAll('product-modal.product-variant-grid-modal').forEach((modal) => {
      if (modal.dataset.variantGridZoomResetBound === 'true') return;
      modal.dataset.variantGridZoomResetBound = 'true';

      const updateModalCaption = () => {
        const captionEl = modal.querySelector('[data-variant-grid-modal-caption]');
        if (!captionEl) return;
        if (!modal.hasAttribute('open')) {
          captionEl.hidden = true;
          captionEl.textContent = '';
          return;
        }
        const active = modal.querySelector('.product-media.active');
        const text = active?.getAttribute('data-caption')?.trim();
        if (text) {
          captionEl.textContent = text;
          captionEl.hidden = false;
        } else {
          captionEl.textContent = '';
          captionEl.hidden = true;
        }
      };

      new MutationObserver(() => {
        if (!modal.hasAttribute('open')) {
          window.dispatchEvent(new CustomEvent('dialog-close'));
          updateModalCaption();
          return;
        }
        requestAnimationFrame(updateModalCaption);
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    });
  };

  const scrollToAnchorId = (anchorId, behavior = 'smooth') => {
    const target = document.getElementById(anchorId);
    if (!target) return false;

    let offset = 0;
    try {
      const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      offset = parseInt(headerHeight, 10) || 0;
    } catch (e) {
      // silent
    }

    if (!offset) {
      const headerEl = document.querySelector('.header-section, .shopify-section-header, header');
      offset = headerEl?.offsetHeight || 0;
    }

    const top = target.getBoundingClientRect().top + window.scrollY - offset - 12;
    window.scrollTo({ top: Math.max(0, top), left: 0, behavior });
    return true;
  };

  if (!window.__pvgAnchorScrollBound) {
    window.__pvgAnchorScrollBound = true;

    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href="#variants"]');
      if (!link) return;
      if (!scrollToAnchorId('variants')) return;
      e.preventDefault();
    });

    if (window.location.hash === '#variants') {
      requestAnimationFrame(() => scrollToAnchorId('variants', 'instant'));
    }
  }

  init();
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target) init(e.target);
  });
})();
